/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wise_Mild_Falcon_MeltInputs */

const en_wise_mild_falcon_melt = /** @type {(inputs: Wise_Mild_Falcon_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_wise_mild_falcon_melt = /** @type {(inputs: Wise_Mild_Falcon_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Wise_Mild_Falcon_MeltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wise_mild_falcon_melt = /** @type {((inputs?: Wise_Mild_Falcon_MeltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wise_Mild_Falcon_MeltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wise_mild_falcon_melt(inputs)
	return de_wise_mild_falcon_melt(inputs)
});